export const TASK_STATUSES = [
  { value: "a_faire", label: "À faire" },
  { value: "en_cours", label: "En cours" },
  { value: "bloque", label: "Bloquée" },
  { value: "a_facturer", label: "À facturer" },
  { value: "terminee", label: "Terminée" },
];

export const TASK_STATUS_META = {
  a_faire: {
    label: "À faire",
    badgeClass: "bg-slate-100 text-slate-700 ring-slate-200",
    headerClass: "bg-slate-50 text-slate-700 border-slate-200",
  },
  en_cours: {
    label: "En cours",
    badgeClass: "bg-blue-100 text-blue-700 ring-blue-200",
    headerClass: "bg-blue-50 text-blue-700 border-blue-200",
  },
  bloque: {
    label: "Bloquée",
    badgeClass: "bg-rose-100 text-rose-700 ring-rose-200",
    headerClass: "bg-rose-50 text-rose-700 border-rose-200",
  },
  a_facturer: {
    label: "À facturer",
    badgeClass: "bg-amber-100 text-amber-700 ring-amber-200",
    headerClass: "bg-amber-50 text-amber-700 border-amber-200",
  },
  terminee: {
    label: "Terminée",
    badgeClass: "bg-emerald-100 text-emerald-700 ring-emerald-200",
    headerClass: "bg-emerald-50 text-emerald-700 border-emerald-200",
  },
};

export const BILLING_STATUSES = {
  non_facturee: {
    label: "Non facturée",
    className: "bg-slate-100 text-slate-700",
  },
  partiellement_facturee: {
    label: "Partiellement facturée",
    className: "bg-amber-100 text-amber-700",
  },
  entierement_facturee: {
    label: "Entièrement facturée",
    className: "bg-emerald-100 text-emerald-700",
  },
};

export const DESKTOP_GRID_CLASS =
  "lg:grid-cols-[minmax(18rem,2.4fr)_9rem_10rem_9rem_11rem]";

export const DRAWER_FIELDS = [
  "client_id",
  "titre",
  "commentaire",
  "notes_internes",
  "statut",
  "heures_estimees",
  "taux_horaire",
  "date_tache",
  "facturable",
];

export const getStatusMeta = (status) =>
  TASK_STATUS_META[status] || TASK_STATUS_META.a_faire;

export const getBillingMeta = (status) =>
  BILLING_STATUSES[status] || BILLING_STATUSES.non_facturee;
